export default function callOnIdle<T>(task: () => Promise<T> | T, timeout: number = 3000) {
    return new Promise<T>(resolve => {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => resolve(task()), { timeout });
        } else {
            resolve(task());
        }
    });
}